import { render } from "./ViewReport.vue?vue&type=template&id=1490d99b&scoped=true"
import script from "./ViewReport.vue?vue&type=script&lang=js"
export * from "./ViewReport.vue?vue&type=script&lang=js"

import "./ViewReport.vue?vue&type=style&index=0&id=1490d99b&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3194113096/src/coop-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1490d99b"]])

export default __exports__